import React from 'react';
import MotifTabNavigation from '@ey/motif-react-wrapper/TabNavigation';
import MotifTabControl from '@ey/motif-react-wrapper/TabControl';
import MotifBadge from '@ey/motif-react-wrapper/Badge';

import StyledTabBarWrapper from './StyledTabBarWrapper';

export default function Tabs(props) {
	const {activeTab, badge, tabs, onTabChange, styleName, tabColor} = props;
	const onClick = (id) => {
		if (id !== activeTab) {
			onTabChange(id);
		}
	};

	return (
		<StyledTabBarWrapper>
			<MotifTabNavigation className={tabColor ? 'darkTab' : ''}>
				{tabs.map((tab) => {
					return (
						<MotifTabControl
							key={tab.id}
							id={tab.id}
							title={tab.label}
							className={activeTab === tab.id ? 'motif-active' : ''}
							onClick={() => onClick(tab.id)}
							disabled={tab.disabled}
						>
							{tab && tab.icon ? tab.icon : ''}
							{tab.label}
							{badge && tab.value > -1 && tab.value !== '' && <MotifBadge value={tab.value} />}
						</MotifTabControl>
					);
				})}
			</MotifTabNavigation>
		</StyledTabBarWrapper>
	);
}
